import { render } from "./AddressForm.vue?vue&type=template&id=7b1b68dc&scoped=true"
import script from "./AddressForm.vue?vue&type=script&lang=js"
export * from "./AddressForm.vue?vue&type=script&lang=js"

import "./AddressForm.vue?vue&type=style&index=0&id=7b1b68dc&lang=scss&scoped=true"
import "./AddressForm.vue?vue&type=style&index=1&id=7b1b68dc&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b1b68dc"]])

export default __exports__